module.exports = __webpack_public_path__ + "static/media/ytIcon.a3eab4d0.svg";